<template>
  <div class="flex flex-col gap-sm pb-sm">
    <div class="text-center" v-if="arendeStore.isLoading">
      <SmallSpinner />
    </div>
    <div
      class="rounded bg-avtalat-gray p-sm"
      id="no-arenden-message"
      v-if="!arendeStore.hasArenden"
    >
      Det finns inga tidigare ärenden
    </div>
    <template v-if="!arendeStore.isLoading && arendeStore.hasArenden">
      <PaginatedArendenList
        id="open-arenden-list"
        heading="Öppna ärenden"
        showMoreTicketsButtonLabel="Visa alla öppna ärenden"
        :arenden="arendeStore.openArenden.arenden"
        :showMore="
          () =>
            arendeStore.fetchArenden(
              arbetsgivareStore.arbetsgivare.foretag?.organisationsnummer!,
              true,
              100,
              apiClient,
            )
        "
        :can-show-more="arendeStore.openArenden.nextLink !== null"
        :is-loading="arendeStore.openArenden.isLoading"
      />
      <PaginatedArendenList
        id="closed-arenden-list"
        heading="Stängda ärenden"
        showMoreTicketsButtonLabel="Visa fler stängda ärenden"
        :arenden="arendeStore.closedArenden.arenden"
        :showMore="
          () =>
            arendeStore.fetchArenden(
              arbetsgivareStore.arbetsgivare.foretag?.organisationsnummer!,
              false,
              5,
              apiClient,
            )
        "
        :can-show-more="arendeStore.closedArenden.nextLink !== null"
        :is-loading="arendeStore.closedArenden.isLoading"
      />
    </template>
  </div>
</template>

<script setup lang="ts">
import PaginatedArendenList from "@/components/arende-components/PaginatedArendenList.vue";
import SmallSpinner from "@/components/ui/SmallSpinner.vue";
import { useApi } from "@/composables/useApi";

import { useArbetsgivareStore, useArbetsgivarearendenStore } from "../store";

const apiClient = useApi();
const arendeStore = useArbetsgivarearendenStore();
const arbetsgivareStore = useArbetsgivareStore();
</script>
